module.exports = __webpack_public_path__ + "static/img/godwealth2_th.9ec399e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/godwealth2_th.png
// module id = aisi
// module chunks = 1